import type { HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

/** Töltés-placeholder (list/detail betöltés alatt). */
function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return <div className={cn('bg-muted animate-pulse rounded-md', className)} {...props} />;
}

export { Skeleton };
